import percentage from './percentage.js'
import currency from './currency.js'

export default {
  install: function (Vue) {
    Vue.filter('percent', percentage)
    Vue.filter('currency', currency)
  }
}
